import { type UpdateHookResponse, mutationUpdate } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useApiKeyCache } from './cache'
import { type ApiKeyUpdateInput, type ApiKeyData, type ApiKeyUpdateSuccess, toResponseError } from '@terros/common'

export function useUpdateApiKey(): UpdateHookResponse<ApiKeyUpdateInput, ApiKeyData> {
  const mutation = useTantalimMutation<ApiKeyUpdateInput, ApiKeyUpdateSuccess>({
    url: '/apikey/update',
  })
  const cache = useApiKeyCache()

  async function update(input: ApiKeyUpdateInput): Promise<ApiKeyData> {
    try {
      const { key } = await mutation.mutateAsync(input)
      cache.replaceItem(key)
      return key
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationUpdate(mutation, update)
}
